import {connect, useSelector} from 'react-redux';
import { useState } from 'react'
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph,
    Button,
    ErrorMark
} from '../../../components/RegularComponents'
import CheckboxForm from '../../../components/CheckBoxForm'
import TopNavigationBar from '../../TopNavigationBar'
import {confirmBeforePaymentSelect} from '../../../redux/selector/confirmBeforePaymentSelector'
import { ERROR_STRING } from '../../../app/errors';
import {
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    // APPLICATION_MODE_RENEW,
    ROUTE_PATH
} from "../../../app/constants"
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from '../../../redux/slice/applicationsUtils';

const RenewalConfirmBeforePayment = (props) => {
    const { agencyApplication }  = useSelector(
        agencyApplicationSelector
    );
    const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType);
    let nextUrl = ROUTE_PATH.ML_APP
    let subTitle = "Mortgage Lender Licence renewal";
    if(applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
        nextUrl = ROUTE_PATH.MA_APP
        subTitle = "Mortgage Administrator Licence renewal";
    }
    // const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
    // const applicationMode = APPLICATION_MODE_RENEW
    const {dispatch, confirmBeforePayment} = props
    const [confirmCheck, setConfirmCheck] = useState(false)
    const [showValidationError,setShowValidationError] = useState(false)

    return (
        <>
            <div className={"container"}>
                <TopNavigationBar {...props} />

                <div className="row bottomMarginMedium">
                    <div className="col-8">
                        <Header 
                            id="confirm-before-payment-header" 
                            header={confirmBeforePayment.header} />
                        <Paragraph
                            id="mra-renewal-confirm-air-text-1"
                            style={{fontWeight: "bold", fontSize: "1.2em"}}
                            text={[subTitle]}
                        />
                        <Paragraph 
                            id="confirm-before-payment-text"
                            text={confirmBeforePayment.text} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-8">
                        <CheckboxForm 
                            id="confirm-before-start-checkbox"
                            checked={confirmCheck}
                            value={confirmCheck}
                            labelText="Yes, I confirm"
                            onCheckBoxChange={(val) => {
                                setShowValidationError(false)
                                setConfirmCheck(val)
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
                        <Button
                            id="cofirm-before-payment-continue-button"
                            buttonType={"regular_primary"}
                            text={"Pay and submit application"}
                            onClick={() => {
                                if(!confirmCheck) { 
                                    setShowValidationError(true)
                                    return
                                }
                                setShowValidationError(false)
                                dispatch(push(`${nextUrl}${ROUTE_PATH.RENEWAL_PAYMENT_PREVIEW}`))
                            }}
                        />
                        {showValidationError && ErrorMark()}
                        {showValidationError && <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.CONFIRM_BEFORE_PAYMENT_CONFIRMATION_NOT_CHECKED}
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(confirmBeforePaymentSelect)(RenewalConfirmBeforePayment)
